import React from 'react';

import autoBind from 'react-autobind';

// import other components within the same project here

class UserDataProfile extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      userInfo:{},
      schoolInfo:{},
      kla:[],
      subject:[],
      subscriptionInfo:[],
      subscriptionPlan: "Standard",
      subscriptionPlanNames: [],
      subscriptionPeriods: [],
      school_storage_used: 0,
      epack_created: 0,
      test: "test"
    };
    autoBind(this);


    // get kla and subject data from database
    //var requestObj;
    //requestObj = {table: "kla",filter: {}};


    // this.props.root.refs.API.request("get_list", requestObj, this.getKLAOK, this.getKLAFail);
    // requestObj = {table: "subject",filter: {}};
    // this.props.root.refs.API.request("get_list", requestObj, this.getSubjectOK, this.getSubjectFail);

  }

  getKLAAndSubjectFromServer(){
    var requestObj;
    requestObj = {
      table: "kla",
      filter: {},
      order_by: "id",
      order_mode: "ASC",
    };
    this.props.root.refs.API.request("get_list", requestObj, this.getKLAOK, this.getKLAFail);
    requestObj = {
      table: "subject",
      filter: {},
      order_by: "id",
      order_mode: "ASC",
    };
    this.props.root.refs.API.request("get_list", requestObj, this.getSubjectOK, this.getSubjectFail);

  }

  updateUserInfo(res){
    console.log("updateUserInfo ");
    this.setState({userInfo: res.body.user_info});
    this.state.userInfo = res.body.user_info;
  }

  updateSchoolInfo(res){
    // console.log("updateSchoolInfo");
    this.setState({schoolInfo: res.body.school_info});
    this.state.schoolInfo = res.body.school_info;
  }

  /**
   * Privilege rows enter the app HERE and nowhere else, so this is where the
   * legacy string contract is restored.
   *
   * The old PHP surface returned every column as a string and ~15 feature gates
   * are written as `getPrivilege('X').value === '1'` (plus SubscriptionDialog's
   * `privilege.value_type === '1'`, which reads this array directly rather than
   * through getPrivilege). The /api surface returns NATIVE ints, and
   * `1 === '1'` is false — every one of those gates would silently turn OFF,
   * with no error anywhere. Normalising the three comparison columns to strings
   * once keeps all of them working, strict and loose alike.
   */
  updateSubscriptionInfo(res){
    console.log("Subscription Info Received:", res);
    const normalized = Array.isArray(res) ? res.map((row) => {
      if (!row || typeof row !== 'object') {
        return row;
      }
      const out = Object.assign({}, row);
      ['value', 'value_2', 'value_type'].forEach((key) => {
        if (out[key] !== null && out[key] !== undefined) {
          out[key] = String(out[key]);
        }
      });
      return out;
    }) : res;
    this.setState({subscriptionInfo: normalized});
    this.state.subscriptionInfo = normalized;
  }

  updateSubscriptionPlan(res){
    this.setState({subscriptionPlan: res});
    this.state.subscriptionPlan = res;
  }

  updateSchoolStorageUsed(res){
    this.setState({school_storage_used: res});
    this.state.school_storage_used = res;
  }

  updateSubscriptionPlanNames(res) {
    // res is an array of dictionaries of subscription_name
    // convert it to arrays used by the subscription dialog
    if (!Array.isArray(res)) { res = []; }
    var subscriptionPlanNames = [];
    var subscriptionPeriods = [];
    for (var i = 0; i < res.length; i++) {
      subscriptionPlanNames.push(res[i].subscription_name);
      subscriptionPeriods.push({
        subscription_name: res[i].subscription_name,
        date_start: res[i].date_start || '',
        date_expire: res[i].date_expire || '',
      });
    }
    this.setState({subscriptionPlanNames: subscriptionPlanNames, subscriptionPeriods: subscriptionPeriods});
    this.state.subscriptionPlanNames = subscriptionPlanNames
    this.state.subscriptionPeriods = subscriptionPeriods
  }

  updateEpackCreated(res){
    this.setState({epack_created: res});
    this.state.epack_created = res;
  }

  // API handlers
  getKLAOK(res){
    const rows = res && res.body && Array.isArray(res.body.result) ? res.body.result : [];
    this.setState({kla: rows})
    this.state.kla = rows;
  }

  getKLAFail(err){
    console.log("get KLA from server failed");
  }

  getSubjectOK(res){
    const rows = res && res.body && Array.isArray(res.body.result) ? res.body.result : [];
    this.setState({subject: rows})
    this.state.subject = rows;
  }

  getSubjectFail(err){
    console.log("get subject from server failed");
  }

  getPrivilege(privilegeName) {
    const defaultPrivilege = {
      privilege_name: "",
      privilege_name_long_zh: "",
      privilege_name_long_en: "",
      value_type: "",
      description: "",
      value: "",
      value_2: ""
    };

    if (!this.state.subscriptionInfo || !Array.isArray(this.state.subscriptionInfo)) {
      return defaultPrivilege;
    }

    const privilege = this.state.subscriptionInfo.find(p => p.privilege_name === privilegeName);
    return privilege || defaultPrivilege;
  }

  getKLAByID(id){
    if (!Array.isArray(this.state.kla)) { return null; }
    for (var i = 0; i < this.state.kla.length; i++) {
      var objKLA = this.state.kla[i];
      if(objKLA.id == id){
        return objKLA;
      }
    }
    return null;
  }

  getSubjectByID(id){
    if (!Array.isArray(this.state.subject)) { return null; }
    for (var i = 0; i < this.state.subject.length; i++) {
      var objSubject = this.state.subject[i];
      if(objSubject.id == id){
        return objSubject;
      }
    }
    return null;
  } 

  render() {
      return (
        <div>

        </div>
      )
  }
}

export default UserDataProfile;
